module.exports = __webpack_public_path__ + "img/fi-rr-rectangle-vertical.d6cb2fd3.svg";